import React from 'react'
import PropTypes from 'prop-types'

import EventDate from 'app/componentV4/MessageDetail/Event/EventDate'
import EventCancel from 'app/componentV4/MessageDetail/Event/EventCancel'
import EventInvitees from 'app/componentV4/MessageDetail/Event/EventInvitees'
import EventLocation from 'app/componentV4/MessageDetail/Event/EventLocation'

const EventDetail = (props) => {
  const { id, data, isPropose, isEventCanceled, canceledReason = null } = props
  const {
    startDate = '',
    endDate = '',
    startTimeZone = '',
    endTimeZone = '',
    address = '',
    actionsCount = {
      going: 0,
      maybe: 0,
      notGoing: 0,
    },
  } = data

  return (
    <>
      <EventDate data={{ startDate, endDate, startTimeZone, endTimeZone }} />
      <EventLocation data={address} />
      {isPropose ? <EventInvitees id={id} data={actionsCount} /> : null}
      {isEventCanceled ? <EventCancel reason={canceledReason} /> : null}
    </>
  )
}

const dataPropTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  startTimeZone: PropTypes.string,
  endTimeZone: PropTypes.string,
  address: PropTypes.string,
  status: PropTypes.number,
  actionsCount: PropTypes.shape({
    going: PropTypes.number,
    maybe: PropTypes.number,
    notGoing: PropTypes.number,
  }),
  isEventCanceled: PropTypes.bool,
  canceledReason: PropTypes.string,
}
EventDetail.propTypes = {
  id: PropTypes.number,
  isPropose: PropTypes.bool,
  isEventCanceled: PropTypes.bool,
  canceledReason: PropTypes.string,
  data: PropTypes.shape(dataPropTypes).isRequired,
}

export default EventDetail
